<template>
  <card>
     <template slot="header">
        <h3 class="card-title">Update NTE Form</h3>
     </template>
     <nav class="row">
        <ol class="breadcrumb arr-right bg-breadcrum">
           <li class="breadcrumb-item">
              <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
           </li>
           <li class="breadcrumb-item">
              <router-link to="/hr/nterequest">NTE Tracker</router-link>
           </li>
           <li class="breadcrumb-item active">Update NTE Form</li>
        </ol>
     </nav>
     <hr style="margin-top:-10px" />
     <div class="float-lg-right"><h3><i class="fa fa-user"></i>&nbsp;&nbsp;{{item.full_name | capitalize}}</h3></div>
    <div class="col-md-12"><br/><br/></div>
     <form @submit.prevent="updateForm">
          <br/>
          <div class="border-box-nte">
             <div class="row">
                <div class="col-md-4 ">
                   <label>Corrective Action To be Taken</label>
                   <select class="form-control" @change="dismissal" v-model="corrective" v-bind:class="{ 'is-invalid': error_handler && error_handler.action_to_be_taken}">
                      <option value="">--Select One --</option>
                      <option value="nte">Notice To Explain</option>
                      <option value="suspension">Suspension</option>
                      <option value="dismissal">Dismissal</option>
                   </select>
                   <span v-if="error_handler.action_to_be_taken" class="invalid-feedback">{{ error_handler.action_to_be_taken[0] }}</span>
                  </div>
                    <div class="col-md-4">
                      <div class="form-group">
                          <label>Date Request</label>
                          <input type="date" v-model="item.date_request" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.date_request}">
                          <span v-if="error_handler.date_request" class="invalid-feedback">{{ error_handler.date_request[0] }}</span>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                          <label>Date Incident</label>
                          <input type="date" v-model="item.date_incident" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.date_incident}">
                          <span v-if="error_handler.date_incident" class="invalid-feedback">{{ error_handler.date_incident[0] }}</span>
                      </div>
                    </div>
                   <!--CORRECTIVE ACTION HERE -->
                    <div v-if="corrective == 'nte'">
                      <div class="col-md-12 ">
                          <font color="red">Select one for your employee action</font>
                          <br/>
                          <input type="radio" v-model="item.action_to_be_taken" value="VW - Verbal Warning"> VW - Verbal Warning
                          <input type="radio" v-model="item.action_to_be_taken" value="NTE 1"> NTE 1
                          <input type="radio" v-model="item.action_to_be_taken" value="NTE 2"> NTE 2
                          <input type="radio" v-model="item.action_to_be_taken" value="NTE 3"> NTE 3
                      </div>
                    </div>
                    <div v-if="corrective == 'suspension'">
                      <div class="col-md-12 ">
                          <font color="red">Select one for your employee action</font>
                          <br/>
                          <input type="radio" v-model="item.action_to_be_taken" value="3 Days Suspension"> 3 Days Suspension
                          <input type="radio" v-model="item.action_to_be_taken" value="10 Days Suspension"> 10 Days Suspension
                      </div>
                    </div>
                  <!--END CORRECTIVE ACTION -->
             </div>
          </div>
          <br/>
          <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Infraction Details</font>
          <div class="border-box-nte">
             <div class="row">
                <div class="col-md-6">
                   <label>Type of Infraction :</label>
                   <select v-model="item.type_of_infraction" @change="get_previous_infraction" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.type_of_infraction}">
                       <option value="">--Select Infraction Type --</option>
                       <option>i. Attendance and Punctuality</option>
                       <option>ii. Time Keeping Infraction</option>
                       <option>iii. Office Protocol and Decorum</option>
                       <option>iv. Neglect of Duty</option>
                       <option>v. Fraud and Similar Acts Prejudicial to Company Interest</option>
                       <option>vi. Health and Sanitation</option>
                       <option>vii. Company Facilities and Property</option>
                       <option>viii. Insubordination</option>
                       <option>ix. Confidentiality of Work and Information</option>
                       <option>x. The Use of Workstations, Computer, Computer Programs, etc.</option>
                       <option>xi. People Management</option>
                       <option>xii. Policy on Call Handling</option>
                       <option>xiii. Sexual Harrassment</option>
                       <option>xiv. Prohibited Drugs and Paraphernalia</option>
                   </select> 
                   <span v-if="error_handler.type_of_infraction" class="invalid-feedback">{{ error_handler.type_of_infraction[0] }}</span>  
             <!-- INFRACTION RECORD HISTORY -->
                <span v-if="infraction_item != ''">
                  <div class="infraction-border">
                    <b>Previous Infraction</b><br/>
                    <span v-for="item in infraction_item">
                        <i class="fa fa-stop-circle-o"></i> {{item.type_of_infraction}} 
                        <a href="javascript:void(0)" @click="get_selected_id(item)" v-b-modal.view-details  v-b-tooltip.hover>&nbsp;<u>View Details</u></a> 
                        <br/>
                    </span>    
                  </div> 
                </span>  
              </div>  
            <!-- END INFRACTION RECORD HISTORY -->       
                <div class="col-md-6">
                   <label>Details of Infraction</label>
                   <textarea class="form-control" v-model="item.details_of_infraction" rows="6" v-bind:class="{ 'is-invalid': error_handler && error_handler.details_of_infraction}"></textarea>
                   <span v-if="error_handler.details_of_infraction" class="invalid-feedback">{{ error_handler.details_of_infraction[0] }}</span>
                </div>
              </div> 
             </div>
          <br/>
          <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i>Details of Occurence</font>
          <div class="border-box-nte">
             <div v-for="(res ,index) in item.occurence">
                <div class="row">
                   <div class="col-md-4">
                      <div class="form-group">
                         <label>Date of Occurence:</label>
                         <input type="date" v-model="res.date" class="form-control">
                      </div>
                   </div>
                   <div class="col-md-8">
                      <div class="form-group">
                         <label>Item Description:</label>
                         <input type="text" v-model="res.detail" class="form-control">
                      </div>
                   </div>
                </div>
                <div class="floater-point">
                   <div class="action-item-occurence">
                      <div class="form-group">
                         <button @click.stop.prevent="add_form" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i></button>
                         <button @click.stop.prevent="delete_form(index)" class="btn btn-xs btn-primary"><i class="fa fa-minus"></i></button>
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <br/>   
          <b>ATTACHMENT FILE</b> 
          <br><br>  
           <!--FILE PREVIEW -->
           <div class="row col-md-12">
            <div class="upload-btn-wrapper ">
               <div v-for="(file,key) in item.data_files" :key="key" class="mb-2">
                  <slot v-if="file.file_type == 'application/pdf'">
                        <i class="fa fa-file-pdf-o fa-2x"></i>
                  </slot>
                  <slot v-else-if="file.file_type=='application/msword'">
                        <i class="fa fa-file-word-o fa-2x"></i>
                  </slot> 
                  <slot v-else-if="file.file_type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                        <i class="fa fa-file-word-o fa-2x"></i>
                  </slot>
                  <slot v-else-if="file.file_type=='image/jpeg'">
                        <i class="fa fa-file-image-o fa-2x"></i>
                     </slot> 
                  <slot v-else-if="file.file_type=='image/png'">
                     <i class="fa fa-file-image-o fa-2x"></i>
                  </slot>   
                     &nbsp;&nbsp; <a :href="'https://endpoint.blueprintbusinesssolutionscorp.com/upload/' + file.file_name" target="_blank">{{file.file_name}}</a>
                     <span @click="removeExistingFiles(key)"><i class="fa fa-close" style="color:red;cursor: pointer;"></i></span>
               </div>
            </div>
           </div>
           <!-- END FILE PREVIEW -->
           <br/>
         <!-- MULTIPLE FILE UPLOAD HERE -->
         <div class="upload-btn-wrapper ">
            <label for="nteFiles" class="custom-file-upload"> <i class="fa fa-upload"></i>Attach Files</label>
            <input type="file" ref="files" id="nteFiles" multiple="multiple" accept=".doc,.docx, .pdf, .jpg, .jpeg, .png, .gif" @change="handleNteFilesUpload"/>  
            <div v-for="(file,key) in nteFiles" :key="key" class="mb-2">
            <slot v-if="file.type == 'application/pdf'">
                  <i class="fa fa-file-pdf-o fa-2x"></i>
            </slot>
            <slot v-else-if="file.type=='application/msword'">
                  <i class="fa fa-file-word-o fa-2x"></i>
            </slot> 
            <slot v-else-if="file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                  <i class="fa fa-file-word-o fa-2x"></i>
            </slot>
            <slot v-else-if="file.type=='image/jpeg'">
                  <i class="fa fa-file-image-o fa-2x"></i>
               </slot> 
            <slot v-else-if="file.type=='image/png'">
               <i class="fa fa-file-image-o fa-2x"></i>
            </slot>   
                  &nbsp;&nbsp; {{file.name}} - {{file.size}}
            <span @click="removenteFilesUpload(key)"><i class="fa fa-close" style="color:red;cursor: pointer;"></i></span>
            </div>                                                                  
         </div>
         <!-- END MULTIPLE FILE UPLOAD HERE -->
           <br/><br/><br/><br/><br/><br/>
          <div class="form-group">
             <div class="float-right">
                <br/>
                <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Request</button>
                <br/>
                <br/>
             </div>
          </div>
          <br/>
          <br/>
       </form>
  </card>
</template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
components: {
  Card,
},

data() {
  return {
    //ITEMS
    item: {},
    nteFiles: [],
    files: [],
    files: {},
    occurence:[
            {
               dates:'',
               detail:''
            }
         ],
    corrective: '',
    error_handler: [],
    selected_item:[],
    type_of_infraction:'',
    infraction_item:[],
   
  }
},

mounted: function () {
  this.getItem()
  this.get_previous_infraction()
},

methods: {

 add_form() {
      this.item.occurence.push({
        date: '',
        detail: ''
      })
 },

delete_form(index) {
   this.item.occurence.splice(index, 1);
   if (index === 0)
   this.add_form()
},   

get_selected_id(item){
    this.selected_item = item
},
get_previous_infraction(id){
    axios.post('api/infraction/find',{
        id: this.item.emp_id,
        type_of_infraction:this.type_of_infraction
    })
    .then(resp => {
        this.infraction_item = resp.data
    })
    .catch(error => {
        console.log(error.response)
    });
  },

  dismissal() {
   if (this.corrective == 'dismissal') {
     this.action_to_be_taken = 'Dismissal'
    }
  },

  getItem() {
    axios.get('api/nterequestbyhr/get/' + this.$route.params.id)
    .then(resp => {
      this.item = resp.data;
      console.log(JSON.stringify(resp.data));
    })
    .catch(error => {
          if (error.response.status == 422) {
            this.error_handler = error.response.data.errors
          }
          console.log('response => ', error.response);
      });
  },

  getDate(date) {
      return moment(date).format('MMM DD YYYY');
  },

//FILE UPLOAD
handleNteFilesUpload() {
   let uploadedNTEFiles = event.target.files;
   if(!uploadedNTEFiles.length)
      return
   for (let i = 0; i < uploadedNTEFiles.length; i++){
         this.nteFiles.push( uploadedNTEFiles[i])
   }
   console.log('response => ', uploadedNTEFiles)
},

removenteFilesUpload(key){
   this.nteFiles.splice(key, 1)
   console.log(this.nteFiles)
},

removeExistingFiles(key){
   this.item.data_files.splice(key, 1)
   console.log(this.item.data_files)
},


    updateForm(e) {
         e.preventDefault();

         //Form data a files to upload
         let formData = new FormData()
         for (var i = 0; i < this.nteFiles.length; i++) {
               let file = this.nteFiles[i];
               formData.append('files[' + i + ']', file);
         }

         //Additional POST Request
         formData.append('existing_files', JSON.stringify(this.item.data_files))
         formData.append('action_to_be_taken', this.item.action_to_be_taken)
         formData.append('date_request', this.item.date_request)
         formData.append('date_incident', this.item.date_incident)
         formData.append('details_of_infraction', this.item.details_of_infraction)
         formData.append('type_of_infraction', this.item.type_of_infraction)
         formData.append('occurence',this.item.occurence)

      this.$swal({
         title: 'Are you sure?',
         text: 'Do you want to save changes.',
         type: 'warning',
         showCancelButton: true,
         showCloseButton: false,
      })
      .then((isConfirm) => {
         if (isConfirm === true) {
   
               axios.post('api/nterequest/approval/update/' + this.item.id, {
                  existing_files:  JSON.stringify(this.item.data_files),
                  action_to_be_taken:  this.item.action_to_be_taken,
                  date_request:  this.item.date_request,
                  date_incident:  this.item.date_incident,
                  details_of_infraction:  this.item.details_of_infraction,
                  type_of_infraction:  this.item.type_of_infraction,
                  occurence: this.item.occurence
                })
                .then(response => {
                  this.$swal({
                  type: 'success',
                  title: 'NTE Request Updated',
                  html: 'NTE Request was<br/> successfully updated.<br/><br/><br/><br/>',
                  showConfirmButton: false,
                  timer: 4000
                  })

                  this.$router.push({
                  name: 'nte-request'
                  });
                  console.log(response.data)
               })
               .catch(error => {
                  console.log(error)
               });
            }
         });
      } 
},

computed: {
   imgpreview(){
      let data = window.axios.defaults.baseURL + '/upload/'
      return data
   }
}
}
</script>
<style>
  input[type="file"] {
        display: none; /* Hide default file input */
    }
    .custom-file-upload {
        display: inline-block;
        background-color: #007bff;
        color: white;
        padding: 10px 15px;
        border-radius: 5px;
        cursor: pointer;
        font-weight: bold;
    }

    .custom-file-upload:hover {
        background-color: #0056b3;
    }
</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-nte-edit-request.vue